import { render } from "./AssistantIcon.vue?vue&type=template&id=52d5929c&scoped=true"
import script from "./AssistantIcon.vue?vue&type=script&lang=js"
export * from "./AssistantIcon.vue?vue&type=script&lang=js"

import "./AssistantIcon.vue?vue&type=style&index=0&id=52d5929c&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52d5929c"]])

export default __exports__